module.exports = __webpack_public_path__ + "media/images/arrows/twisted/cyan-ca8041083d16d31d1863863eff4af84c.svg";